exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@page{size:auto;margin:0;padding:0}@media print{body{size:A4;min-height:0;padding:0;margin:0 auto;background-color:#fff}body #CountryBackBt,body .ceq_header,body .profile_idcard{display:none!important}body .page{margin-top:0}body .page .page_wrapper{width:100%}body .page_country{padding:0;background-color:#fff}body .country_chartblock{width:210mm;height:297mm;border:medium none currentColor;border:initial;border-radius:0;border-radius:initial;page-break-after:always;background-color:#fff;display:-webkit-box;display:-ms-flexbox;display:flex;margin:0 auto;margin-top:0;padding:10mm;-webkit-box-shadow:0 0 50px rgba(0,0,0,.5);box-shadow:0 0 50px rgba(0,0,0,.5)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--5-1!./node_modules/postcss-loader/lib??ref--5-2!./node_modules/sass-loader/dist/cjs.js??ref--5-3!./assets/scss/print.scss
// module id = av+t
// module chunks = 11